import Pagination from "react-bootstrap/Pagination";
import axios from "axios";
import { useEffect, useState } from "react";
import Card from "../Card";
import ResutsByRating from "./ResutsByRating";
const key = "b55d580200c51623fe9608f8f064a09b";

let moviesData = [];

const FilterForm = () => {
  const [showMovies, setShowMovies] = useState("");
  const [pageToShow, setPageToShow] = useState("");

  const [maxRating, setMaxRating] = useState("");
  const [minRating, setMinRating] = useState("");

  useEffect(() => {
    getMoviesByRating();
  }, [pageToShow]);

  useEffect(() => {
    getMoviesByRating();
  }, [minRating, maxRating]);

  const getMoviesByRating = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=${key}&vote_average.gte=${minRating}&vote_average.lte=${maxRating}&sort_by=vote_average.des&page=${pageToShow}`
    );
    setShowMovies(response.data.results);
  };

  const starsDefault = [
    "fa-regular fa-star",
    "fa-regular fa-star",
    "fa-regular fa-star",
    "fa-regular fa-star",
    "fa-regular fa-star",
  ];
  const [starsColor, setStarsColor] = useState([...starsDefault]);
  const [isFiltrado, setIsFiltrado] = useState("");

  const handlerFiltro = (min, max, whichStar) => {
    setStarsColor(() => {
      const aux = [...starsDefault];
      for (let i = 0; i < whichStar; i++) {
        aux[i] = "fa-solid fa-star";
      }
      return aux;
    });

    setMinRating(min);
    setMaxRating(max);
    setPageToShow(1);

    if (isFiltrado !== "") {
      setIsFiltrado((prevState) => {
        if (
          prevState === whichStar &&
          starsColor[whichStar] === "fa-solid fa-star"
        ) {
          // TODO Arreglar deseleccionar filtro cambiando el if y eso
          // if (prevState === whichStar) {
          setShowMovies(() => {
            return moviesData;
          });
          setStarsColor(() => {
            return [...starsDefault];
          });

          return "";
        } else {
          return whichStar;
        }
      });
    } else {
      setIsFiltrado((prevState) => {
        return whichStar;
      });
    }
  };

  return (
    <div className="pt-4 " style={{ minHeight: "90vh" }}>
      <h2 className="genreTitle text-start pt-5 ms-3 mb-3">
        Search movies by rating!
      </h2>
      {/* FILTRO----------- */}
      <div className="filtro-container">
        <div className="filtro d-flex align-items-center">
          <span className="filtro__icons d-flex">
            <div onClick={() => handlerFiltro(1, 2, 1)}>
              <i className={starsColor[0]}></i>
            </div>
            <div onClick={() => handlerFiltro(2, 4, 2)}>
              <i className={starsColor[1]}></i>
            </div>
            <div onClick={() => handlerFiltro(4, 6, 3)}>
              <i className={starsColor[2]}></i>
            </div>
            <div onClick={() => handlerFiltro(6, 8, 4)}>
              <i className={starsColor[3]}></i>
            </div>
            <div onClick={() => handlerFiltro(8, 10, 5)}>
              <i className={starsColor[4]}></i>
            </div>
          </span>
        </div>
      </div>

      <div className="form-container input-group pt-4"></div>
      <h3
        className=" text-start ms-3 mb-1 "
        style={{ color: "rgb(187, 187, 187)" }}
      >
        Results
      </h3>
      <hr className="text-muted mx-3" />
      {maxRating !== "" && (
        <div className="paginationDiv">
          <div className="pagination p-2">
            {/*  */}
            <div
              className="prevPage"
              onClick={() => {
                // window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (prevState === 1) {
                    return 1;
                  }
                  return prevState - 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>

            <div
              className="nextPage"
              onClick={() => {
                // window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (showMovies.length === 0) {
                    return prevState;
                  }
                  return prevState + 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>
            {/*  */}
          </div>
        </div>
      )}

      <ResutsByRating showMoviesByTitle={showMovies} pageToShow={pageToShow} />

      {maxRating !== "" && (
        <div className="paginationDiv">
          <div className="pagination p-2">
            {/*  */}
            <div
              className="prevPage"
              onClick={() => {
                window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (prevState === 1) {
                    return 1;
                  }
                  return prevState - 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>

            <div
              className="nextPage"
              onClick={() => {
                window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (showMovies.length === 0) {
                    return prevState;
                  }
                  return prevState + 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>
            {/*  */}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterForm;
